import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { InjectedFormProps, reduxForm, getFormValues } from "redux-form";

import {
	FeesAchFields,
	FeesAdditionalFields,
	FeesAriseFields,
	FeesMonthlyFields,
	FeesTabsFields,
} from "components";
import FeesTemplateContext from "components/applicationFormFields/fees/feesTemplateContext";
import { AchProcessorTypes } from "types";

type FeesSingleFormProps = {
	businessFormName?: string;
	feeTemplateDropdownEnabled?: boolean;
	feesTemplateConfig?: any;
	isMerchantFeesPage?: boolean;
	achProcessor: string;
	isMpaUpload?: boolean;
	setWebsiteUpdatedValue?: Function;
	initialValues?: { [key: string]: any };
};

const FeesSingleForm = ({
	feeTemplateDropdownEnabled = true,
	form,
	businessFormName = "businessForm",
	feesTemplateConfig = {},
	handleSubmit,
	isMerchantFeesPage = false,
	achProcessor,
	// Remove after RC-11160
	isMpaUpload = false,
	setWebsiteUpdatedValue = () => {},
	initialValues,
}: InjectedFormProps<any, FeesSingleFormProps> & FeesSingleFormProps) => {
	const formValues: any = useSelector(getFormValues(form)) || {};

	const isAchProcessor = useMemo(
		() => achProcessor === AchProcessorTypes.Straddle.name,
		[achProcessor],
	);

	return (
		<Form onSubmit={handleSubmit}>
			<p className="text-grey mb-3">Fees</p>
			<FeesTemplateContext.Provider value={feesTemplateConfig}>
				<FeesTabsFields
					formName={form}
					feeProgram={formValues?.feeProgram}
					feeTemplateDropdownEnabled={feeTemplateDropdownEnabled}
				/>
				<hr className="line" />
				<FeesAdditionalFields
					form={form}
					formValues={formValues}
					isMerchantFeesPage={isMerchantFeesPage}
				/>
				<hr className="line" />
				<FeesMonthlyFields
					formValues={formValues}
					businessFormName={businessFormName}
					isMerchantFeesPage={isMerchantFeesPage}
				/>
				{isAchProcessor && !isMpaUpload && (
					<>
						<hr className="line" />
						<FeesAchFields />
					</>
				)}
				{!isMpaUpload && (
					<>
						<hr className="line" />
						<FeesAriseFields
							setWebsiteUpdatedValue={setWebsiteUpdatedValue}
							businessFormName={businessFormName}
							isMerchantFeesPage={isMerchantFeesPage}
							formName={form}
							formValues={formValues}
							initialValues={initialValues}
						/>
					</>
				)}
			</FeesTemplateContext.Provider>
		</Form>
	);
};

export default reduxForm<any, FeesSingleFormProps>({
	enableReinitialize: true,
	keepDirtyOnReinitialize: true,
})(FeesSingleForm);
